/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rounds_No_Rounds_RecordedInputs */



/**
* | output |
* | --- |
* | "No rounds recorded." |
*
* @param {Rounds_No_Rounds_RecordedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_no_rounds_recorded = /** @type {((inputs?: Rounds_No_Rounds_RecordedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_No_Rounds_RecordedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune ronde enregistrée.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay rondas registradas.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhuma rodada registrada.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun round registrato.")
	return /** @type {LocalizedString} */ ("No rounds recorded.")
});